import React from 'react';
import { useLocation } from 'react-router-dom';
import { Home, Calendar, Users, Plus } from 'lucide-react';
import { PrefetchLink } from './PrefetchLink';

export const BottomNav: React.FC = () => {
  const location = useLocation();

  const navItems = [
    { to: '/dashboard', label: 'Home', icon: Home, testId: 'bottom-nav-home' },
    { to: '/meetups', label: 'Meetups', icon: Calendar, testId: 'bottom-nav-meetups' },
    { to: '/meetups/new/wizard', label: 'Create', icon: Plus, special: true, testId: 'bottom-nav-create' },
    { to: '/friends', label: 'Friends', icon: Users, testId: 'bottom-nav-friends' },
  ];

  return (
    <nav
      className="tab-bar-ios md:hidden"
      role="navigation"
      aria-label="Main navigation"
    >
      {navItems.map((item) => {
        const Icon = item.icon;
        const isActive = location.pathname === item.to;

        if (item.special) {
          return (
            <PrefetchLink
              key={item.to}
              to={item.to}
              className="fab-nav"
              aria-label={item.label}
              role="button"
              data-testid={item.testId}
            >
              <Icon className="w-6 h-6" />
            </PrefetchLink>
          );
        }

        return (
          <PrefetchLink
            key={item.to}
            to={item.to}
            className={`tab-ios ${isActive ? 'tab-ios-active' : ''}`}
            aria-current={isActive ? 'page' : undefined}
            aria-label={item.label}
            data-testid={item.testId}
          >
            <Icon className="tab-ios-icon" aria-hidden="true" />
            <span className="tab-ios-label">{item.label}</span>
          </PrefetchLink>
        );
      })}
    </nav>
  );
};